<template>
  <div class="col-lg-12 text-center m-t-30">
    <img src="/images/city-building.svg" alt="Nenhum resultado encontrado" class="m-b-20" style="max-width: 24rem" />

    <h2 style="font-size: 1.5em">Não encontramos anúncios que correspondam exatamente à sua busca.</h2>

    <p class="m-t-40" v-if="properties.length > 0" style="text-align: left; font-weight: bold; font-size: 1.1em">Anúncios similares que podem te interessar:</p>
  </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        properties() {
            return this.$store.getters.getAds;
        }
    },
    mounted() {
        window.dataLayer.push({
            event: 'empty_search',
            event_category: 'search_page',
            event_label: this.$store.getters.getCitySlug,
            search_results: this.properties.length
        });
    }
};
</script>
